import { useAuthContext } from "@/components/AuthProvider";
import Box from "@/components/Box";
import ReleaseButton from "@/components/navigation/common/ReleaseButton";
import RegenerusLogo from "@/images/RegenerusLogoWithoutDots";
import { PanelBoxV2 } from "@/tpo/Boxes";
import Group from "@/tpo/Group";

import AccountsMenu from "../common/AccountsMenu";
import BurgerMenu from "./PatientLoggedInBurgerMenu";

export default function PatientLoggedInNavigation({ accounts = [], hideNav = false }) {
  const links = accounts.flatMap(section => section.links);

  const authContext = useAuthContext();
  const impersonated = authContext?.user?.impersonated;

  return (
    <PanelBoxV2
      maxWidth={1538}
      outer={{
        px: [16, 16, 20],
        position: "fixed",
        top: 40,
        left: 0,
        right: 0,
        bg: "transparent",
        zIndex: 4,
        "data-component-name": "LoggedOutNavHeader"
      }}
      inner={{
        height: [48, 48, 60]
      }}
    >
      <Group
        alignItems="center"
        justifyContent="space-between"
        gap={10}
        data-component-name="LoggedInNavigation"
        height={[48, 48, 60]}
      >
        <Box
          flexGrow={1}
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          bg="dark"
          height="100%"
          borderRadius="10px"
          pl={24}
        >
          <Group>
            <RegenerusLogo fill="white" width={[125, 158, 215]} height={30} />
            {impersonated && <ReleaseButton user={authContext?.user} />}
          </Group>
          {!hideNav && (
            <Group alignItems="center">
              {links.length > 1 && (
                <AccountsMenu accounts={accounts} display={["none", "none", "flex"]} />
              )}
              <BurgerMenu
                accounts={accounts}
                burgerButtonProps={{ height: [48, 48, 60], width: [48, 48, 60] }}
              />
            </Group>
          )}
        </Box>
      </Group>
    </PanelBoxV2>
  );
}
